import { Box, Button, Grid, IconButton, Menu, MenuItem, Stack, Typography, Tooltip } from "@mzc-pdc/ui";
import { IconArrowDropDown, IconArrowDropUp, IconDown, IconSort, IconUp } from "@mzc-cloudplex/icons";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import theme from "@styles/theme";

const TableSort = ({ onChangeSort, onChangeSortAsc, sortOptions, selectedIndex, isSortAsc }) => {
    const { t } = useTranslation();
    const [sortAnchorEl, setSortAnchorEl] = useState(null);

    const sortOpen = Boolean(sortAnchorEl);
    const handleClickListItem = (e, index) => {
        setSortAnchorEl(e.currentTarget);
    };

    const handleChangeSort = (index) => {
        setSortAnchorEl(null);
        onChangeSort(index);
    };

    const handleSortClose = () => {
        setSortAnchorEl(null);
    };

    const handleChangeSortAsc = (value) => {
        onChangeSortAsc && onChangeSortAsc(value);
    };

    const sortLabel = useMemo(() => {
        const label = sortOptions[selectedIndex]?.label ?? "Sort by";
        return t(`common::label::${label}`, label);
    }, [selectedIndex]);

    useEffect(() => {
        if (selectedIndex === null || selectedIndex === undefined) {
            const defaultIndex = sortOptions.findIndex((option) => option.label === "Created");
            onChangeSort(defaultIndex);
        }
    }, [selectedIndex]);

    return (
        <Grid container flexDirection={"row"} width={"100%"} alignItems={"center"}>
            <Grid item>
                <Button
                    variant={"text"}
                    startIcon={<IconSort size={16} />}
                    size={"small"}
                    color={"greySecondary"}
                    onClick={handleClickListItem}
                >
                    {t(`common::label::${sortLabel}`, sortLabel)}
                </Button>
                <Menu anchorEl={sortAnchorEl} open={sortOpen} onClose={handleSortClose}>
                    {sortOptions?.map((option, index) => (
                        <MenuItem
                            key={`sort-menu-item-${index}`}
                            onClick={(e) => handleChangeSort(index)}
                            selected={index === selectedIndex}
                        >
                            {t(`common::label::${option.label}`, option.label)}
                        </MenuItem>
                    ))}
                </Menu>
            </Grid>
            <Grid item>
                <Stack direction={"column"} gap={0.25}>
                    <Tooltip title={t(`common::label::Reverse sort direction`, "Reverse sort direction")}>
                        {isSortAsc ? (
                            <IconButton circled size={"small"} onClick={(e) => handleChangeSortAsc(false)}>
                                <IconUp size={16} color={theme.palette.greySecondary.main} />
                            </IconButton>
                        ) : (
                            <IconButton circled size={"small"} onClick={(e) => handleChangeSortAsc(true)}>
                                <IconDown size={16} color={theme.palette.greySecondary.main} />
                            </IconButton>
                        )}
                    </Tooltip>
                </Stack>
            </Grid>
        </Grid>
    );
};

export default TableSort;
